// Offer Modal functionality
document.addEventListener('DOMContentLoaded', function() {
    var offerModal = document.getElementById('offerModal');
    if (!offerModal) return;

    var addToCartBtn = document.querySelector('.add-to-cart');
    var modalType = offerModal.getAttribute('data-modal-type') || 'standard';
    var collectionsToCheck = JSON.parse(offerModal.getAttribute('data-collections-to-check') || '[]');
    var productCollections = JSON.parse(offerModal.getAttribute('data-product-collections') || '[]');
  
    let previousCartItemCount = 0;
  
    function showModal() {
      offerModal.style.display = 'block';
      setTimeout(() => {
        offerModal.classList.add('active');
        setTimeout(() => {
          offerModal.classList.add('shake');
          setTimeout(() => {
            offerModal.classList.remove('shake');
          }, 2000);
        }, 500);
      }, 10);
    }

    function hideModal() {
      offerModal.classList.remove('active');
      setTimeout(() => {
        offerModal.style.display = 'none';
        offerModal.classList.remove('shake');
      }, 500);
    }
  
    function isProductInCollectionsToCheck() {
      return productCollections.some(collection => collectionsToCheck.includes(collection));
    }
  
    function checkCartAndShowModal() {
      if (!isProductInCollectionsToCheck()) return;

      if (modalType === 'standard') {
        showModal();
      } else if (modalType === 'buyxgety') {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            let currentCartItemCount = cart.items.reduce((total, item) => total + item.quantity, 0);

            if (currentCartItemCount > previousCartItemCount) {
              if (currentCartItemCount % 2 !== 0) {
                showModal();
              }
              previousCartItemCount = currentCartItemCount;
            }
          })
          .catch(function() {});
      }
    }
  
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(event) {
        setTimeout(checkCartAndShowModal, 500);
      });
    }
  
    // Initialize previousCartItemCount when the page loads
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        previousCartItemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
      })
      .catch(function() {});
  
    offerModal.querySelector('.close-modal-btn').addEventListener('click', hideModal);
  });
  
